import React from 'react';
import './css/index.scss';

function TableRow({ children, dashed, onClick, style }) {
  return (
    <div
      className={`table_row ${dashed ? 'dashed' : ''}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </div>
  );
}

export default TableRow;
